/**
 * Application Configuration
 * Centralized configuration for the entire application
 */
import { API_BASE_URL } from '../constants/api.constants';

const config = {
  // API Configuration
  api: {
    baseURL: API_BASE_URL,
    timeout: 10000,
    retryAttempts: 3,
    retryDelay: 1000,
  },

  // App Configuration
  app: {
    name: 'Scalable Frontend',
    version: '1.0.0',
    environment: process.env.NODE_ENV || 'development',
    debug: process.env.NODE_ENV === 'development',
  },

  // Feature Flags
  features: {
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableErrorReporting: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
    enablePWA: process.env.REACT_APP_ENABLE_PWA === 'true',
  },

  // UI Configuration
  ui: {
    theme: {
      primary: '#007bff',
      secondary: '#6c757d',
      success: '#28a745',
      danger: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
    },
    breakpoints: {
      mobile: 576,
      tablet: 768,
      desktop: 992,
      large: 1200,
    },
  },

  // Local Storage Keys
  storage: {
    authToken: 'auth_token',
    userPreferences: 'user_preferences',
    theme: 'app_theme',
  },

  // Validation Rules
  validation: {
    password: {
      minLength: 8,
      requireUppercase: true,
      requireLowercase: true,
      requireNumbers: true,
      requireSpecialChars: true,
    },
    email: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    },
  },
};

export default config; 